export const useLoginWithLinkedin = (additionalParams = {}) => {
  const linkedinClientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
  let redirectURI = `${process.env.REACT_APP_FE_URL}/linkedin/callback`;
  const scope = "openid profile email";
  const login = () => {
    const state = btoa(JSON.stringify(additionalParams)); // encode to safely pass JSON
    const linkedinURL = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${linkedinClientId}&redirect_uri=${encodeURIComponent(
      redirectURI
    )}&scope=${scope}&state=${state}`;
    window.location.href = linkedinURL;
  };
  return login;
};
